export class ProductType {
    Value: string;
    Name: string;

    constructor(value?: string, name?: string) {
        this.Value=value;
        this.Name=name;

    }
}